import * as React from 'react';

import { calculatePreviousTotal } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface IPreviousTotalRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
  negateAmount?: boolean;
}

const getLabel = (periodType: 'month' | 'year' | null): string | null => {
  if (periodType === 'month') {
    return 'Total last month';
  } else if (periodType === 'year') {
    return 'Total last year';
  }
  return null;
};

const PreviousTotalRow = ({
  transactions,
  dateRange,
  colored = false,
  showSign = false,
  negateAmount = false,
}: IPreviousTotalRowProps) => {
  const result = React.useMemo(() => calculatePreviousTotal(transactions, dateRange), [transactions, dateRange]);

  const label = getLabel(result.periodType);
  const value = negateAmount ? -result.value : result.value;

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = React.useMemo(() => toCurrency(value, { showSign }), [value, showSign]);

  if (!label || result.value === null) {
    return null;
  }

  return <Widget.Row variant="summary" label={label} value={formattedValue} valueClassName={valueClassName} />;
};

export default PreviousTotalRow;
